import { render, staticRenderFns } from "./ChannelPartnerSectionTitle.vue?vue&type=template&id=3435b10a&"
import script from "./ChannelPartnerSectionTitle.vue?vue&type=script&lang=js&"
export * from "./ChannelPartnerSectionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports